import requests from './httpService';

const SchoolService = {
  getAllRegisteredSchools() {
    return requests.get("/registration/list");
  },
  getAllSchool(id) {
    return requests.get(`/registration/list/${id}`);
  },
  getAllSchoolList() {
    return requests.post(`/registration/find`,{});
  },
   getAllStudentListInSchool() {
    return requests.post(`/registration/studentcount`,{});
  },
  upadeSchool(body) {
    return requests.put(`/registration/${body._id}`,body); 
  },
  resetSchoolPassword(schoolId, body = {}) {
    return requests.post(`/registration/${schoolId}/reset-password`, body);
  },
 
  getAllStudentById(id,body){
    return requests.post(`/student/list/${id}`,body); 
  },
  deleteStudent(id){
    return requests.delete(`/student/${id}`); 
  },
  upadeStudent(body) {
    return requests.put(`/student/${body._id}`,body); 
  },
  
  getSchooleRegistrationById(id){
    return requests.get(`/registration/${id}`);
  },

 
};

export default SchoolService;
